import { Card, Typography, Alert, Tag } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { useAppNavigate } from '@/hooks'
import SystemHeader from '@/widgets/layout/SystemHeader'
import { BackButton } from '@/widgets/demo/ListPrimitives'

const MfaSettings = () => {
  const navigate = useAppNavigate()

  return (
    <>
      <SystemHeader breadcrumbs={[{ label: 'MFA 設定' }]} />
      <div className="mx-auto w-full max-w-3xl px-6 py-8">
        <BackButton onClick={() => navigate('home')} />
        <Typography.Title level={3}>多要素認証 (MFA) 設定</Typography.Title>
        <Typography.Paragraph type="secondary">
          本システムでは、登録されたメールアドレスに認証コードを送信する「メール認証」を全ユーザー必須でご利用いただきます。
        </Typography.Paragraph>

        <Card>
          <div className="flex items-start gap-4 py-2">
            <div className="text-2xl text-blue-500 mt-1">
              <MailOutlined />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <Typography.Text strong>メール認証</Typography.Text>
                <Tag color="success">認証済</Tag>
              </div>
              <Typography.Text type="secondary" className="text-sm">
                登録済みのメールアドレスに認証コードを送信します。ログイン時にコードの入力が必要です。
              </Typography.Text>
            </div>
          </div>
        </Card>

        <Alert
          className="mt-4"
          type="info"
          showIcon
          message="メール認証は全ユーザー必須です"
          description="セキュリティ確保のため、無効化することはできません。メールアドレスの変更が必要な場合は管理者にご相談ください。"
        />
      </div>
    </>
  )
}

export default MfaSettings
